import React, { useEffect } from 'react';
import { ScheduleHero } from './schedule/ScheduleHero';
import { ScheduleTableBlock } from './schedule/ScheduleTableBlock';
import { ScheduleNotes } from './schedule/ScheduleNotes';
import { ScheduleForm } from './schedule/ScheduleForm';
import { ScheduleFinalCTA } from './schedule/ScheduleFinalCTA';
export function Schedule() {
  useEffect(() => {
    document.title = 'Class Schedule | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2940">
      <ScheduleHero data-id="element-2941" />
      <section className="py-24" data-id="element-2942">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2943">
          <div className="grid lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-2944">
            {/* Left: schedule */}
            <div className="lg:col-span-2" data-id="element-2945">
              <ScheduleTableBlock data-id="element-2946" />
              <ScheduleNotes data-id="element-2947" />
            </div>
            {/* Right: form */}
            <div className="lg:col-span-1" data-id="element-2948">
              <ScheduleForm data-id="element-2949" />
            </div>
          </div>
        </div>
      </section>
      <ScheduleFinalCTA data-id="element-2950" />
    </div>;
}